
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-new-follow-tracker",
      function () {
        return require("private-next-pages/instagram-new-follow-tracker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-new-follow-tracker"])
      });
    }
  